import styled from 'styled-components';

import { LinkButton } from '../LinkButton/wrappers';
import { size, rem } from '../layout/helpers';
import { theme } from '../layout/theme';

export const MediaContainer = styled.div`
  margin-right: ${size(2)};
  flex: 0 0 auto;

  &.v-align-top {
    align-self: flex-start;
  }
`;

export const Image = styled.img`
  max-height: 56px;
  max-width: 56px;
  object-fit: contain;
  display: block;

  &.round {
    border-radius: 50%;
    box-shadow: 0 0 0 1px ${theme.colors.border.main};
  }
`;

export const TextContainer = styled.div`
  flex-grow: 1;
  font-size: ${rem(14)};
  margin-right: ${size(2)};

  ${theme.screens.Md} {
    font-size: ${rem(16)};
  }
`;

export const Label = styled.div`
  color: ${theme.colors.text.ghost};
`;

export const Value = styled.div`
  font-weight: 600;
`;

export const Action = styled(LinkButton).attrs((props) => ({
  className: props.className,
}))`
  position: static;
  font-weight: 600;

  &:not(.prevent-bubbling) {
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const Help = styled.div`
  color: ${theme.colors.text.ghost};
`;

export const ValueButton = styled.div`
  padding: ${size(2)};
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;

  & + & {
    margin-top: ${size(2)};
    border-top: 1px solid ${theme.colors.border.main};
  }

  &.padding-none {
    padding: 0;

    & + & {
      padding-top: ${size(2)};
    }
  }

  &.active {
    ${Action} {
      color: ${theme.colors.ui.positive};
      cursor: default;

      &:hover {
        text-decoration: none;
      }
    }
  }

  &.border {
    border-radius: 8px;
    border: 1px solid ${theme.colors.border.main};
  }

  ${theme.screens.Md} {
    & + &,
    &.padding-none + &.padding-none {
      margin-top: ${size(3)};
      padding-top: ${size(3)};
    }
  }

  &.invisible {
    visibility: hidden;
  }
`;
